module.exports = __webpack_public_path__ + "static/media/NotificationBell.a50f85f7.PNG";